<template>
	<transition name="fade">
		<div v-show="open" class="modal-popup" :class="{ active: open }">
			<div class="popup-overlay"></div>

			<div class="container">
				<div class="popup">
					<div class="row">
						<modal-side v-once title="Modal.NewsletterAuthorizations.Title"></modal-side>

						<div class="col-md-9 popup-container text-center">
							<form autocomplete="off" @submit.prevent="sendForm" @reset.prevent="closeModal">
								<div class="popup-form margin-top-80 margin-bottom-30">
									<div class="form-text margin-bottom-30">{{ $t('Modal.NewsletterAuthorizations.Intro') }}</div>
									<p
										v-html="
											$t('Sentence.NewsletterModalTermsAndConditions', [
												'/termini-e-condizioni',
												'https://www.iubenda.com/privacy-policy/57462537',
											])
										"
									/>

									<!-- <div class="form-container in-modal no-border no-shadow margin-bottom-10">
										<div class="row form-text-container">
											<div class="col-md-12 col-sm-12 col-xs-12 padding-bottom-30">
												<p class="small" v-html="$t('Sentence.NewsletterModalPrivacyRead', ['/privacy'])" />
												<p class="small no-spaces">{{ $t('Sentence.NewsletterModalAuthorizationMarketing') }}:</p>
												<form-radio-group
													id="subscribe_auth_marketing"
													v-model="subscribeAuthMarketing"
													label1="Action.GiveConsent"
													label2="Action.DoNotGiveConsent"
													:value1="1"
													:value2="0"
													:value="subscribeAuthMarketing"
												/>
												<p class="small no-spaces">{{ $t('Sentence.NewsletterModalAuthorizationPartner') }}:</p>
												<form-radio-group
													id="subscribe_auth_marketing_partner"
													v-model="subscribeAuthMarketingPartner"
													label1="Action.GiveConsent"
													label2="Action.DoNotGiveConsent"
													:value1="1"
													:value2="0"
													:value="subscribeAuthMarketingPartner"
													:disabled="subscribeAuthMarketing === 0"
												/>
												<p class="small no-spaces">{{ $t('Sentence.NewsletterModalAuthorizationProfiling') }}:</p>
												<form-radio-group
													id="subscribe_auth_marketing_profiling"
													v-model="subscribeAuthMarketingProfiling"
													label1="Action.GiveConsent"
													label2="Action.DoNotGiveConsent"
													:value1="1"
													:value2="0"
													:value="subscribeAuthMarketingProfiling"
													:disabled="subscribeAuthMarketing === 0"
												/>
											</div>
										</div>
									</div> -->
								</div>
								<form-button label="Button.Cancel" component-class="button-3" type="reset"></form-button>
								<form-button label="Button.Confirm" component-class="button-6"></form-button>
							</form>
						</div>

						<div class="close-btn" @click="closeModal">
							<i class="fa fa-close"></i>
						</div>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
import FormButton from '@/components/atoms/FormButton'
import ModalHelper from '@/mixins/ModalHelper'
import ModalSide from '@/components/modals/ModalSide'

export default {
	name: 'NewsletterAuthorizationsModal',
	components: {
		FormButton,
		ModalSide,
	},
	mixins: [ModalHelper],
	props: {
		subscribeEmail: {
			type: String,
			required: true,
		},
	},
	data() {
		return {
			subscribeAuthMarketing: '',
			subscribeAuthMarketingPartner: '',
			subscribeAuthMarketingProfiling: '',
		}
	},
	watch: {
		subscribeAuthMarketing: function (newValue) {
			// Reset consents after auth marketing changes
			if (newValue === 0 || newValue === false) {
				this.subscribeAuthMarketingPartner = 0
				this.subscribeAuthMarketingProfiling = 0
			} else {
				this.subscribeAuthMarketingPartner = ''
				this.subscribeAuthMarketingProfiling = ''
			}
		},
	},
	mounted() {
		// Listen for open modal event
		this.$root.$on('open-newsletter-authorizations-modal', () => {
			this.open = !this.open
		})
	},
	destroyed() {
		// This prevents from having memory leaks
		this.$root.$off('open-newsletter-authorizations-modal')
	},
	methods: {
		// resetForm() {
		// 	this.subscribeAuthMarketing = ''
		// 	this.subscribeAuthMarketingPartner = ''
		// 	this.subscribeAuthMarketingProfiling = ''
		// },
		sendForm() {
			// Add to newsletter users
			axios
				.post('/newsletters/add', {
					email: this.subscribeEmail,
					auth_marketing: this.subscribeAuthMarketing,
					auth_marketing_partner: this.subscribeAuthMarketingPartner,
					auth_marketing_profiling: this.subscribeAuthMarketingProfiling,
				})
				.then(() => {
					// this.resetForm()

					this.showToastSuccess('SubscriptionConfirmed', 'OperationSuccess')
				})
				.catch((error) => {
					// this.resetForm()

					// Manage errors
					this.errors = error.response.data.info
						? Object.values(error.response.data.info)
						: new Array(error.response.data.message)

					this.showToastError('ErrorSubscribing', this.errors)
				})

			// Emit submit event
			this.$root.$emit('newsletter-authorizations-modal-submit')

			// Close modal
			this.closeModal()
		},
	},
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-to {
	opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/utils/modals/misc/NewsletterAuthorizationsModal.vue